import { Node } from '../Node';
import { NodeModelTypeEnum } from '../enums';

export class InfluentFlowSensorNodeModel extends Node {
  constructor(device?, options = {}) {
    super({
      device,
      options,
      type: NodeModelTypeEnum.InfluentFlowSensor,
    });
  }
}
